import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../Redux";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import UserInterface from "../../Components/InnerLayout/UserInterface";
const Pricing = (params) => {
  const dispatch = useDispatch();

  const menuPricingDetails = useSelector(
    (state) => state?.menuReducer?.menuPricingDetails
  );

  const [postState, setPostState] = useState();
  useEffect(() => {
    dispatch(actions?.getMenuPricingDetails());
  }, []);
  function getPostFormatData() {
    let res = menuPricingDetails?.menuItems?.map((item) => {
      return {
        id: item?.id,
        PosMenuitemsPrice: item?.pos_menuitems_price?.map((el) => {
          return {
            id: el?.id,
            isChanged: 0,
            menu_price: el?.menu_price,
            profit_margin: el?.profit_margin,
          };
        }),
      };
    });
    return res;
  }
  useEffect(() => {
    setPostState(getPostFormatData());
  }, [menuPricingDetails]);

  function handleClick(targetKey, mainId, subId, type) {
    const tempState = JSON.parse(JSON.stringify(postState));
    tempState?.forEach((mainEl) => {
      if (mainEl?.id === mainId) {
        mainEl?.PosMenuitemsPrice?.forEach((subEl) => {
          if (subEl?.id === subId) {
            console.log("here", subId);
            subEl["isChanged"] = 1;
            subEl[targetKey] =
              type === "inc" ? subEl[targetKey] + 1 : subEl[targetKey] - 1;
          }
        });
      }
    });
    setPostState(tempState);
    // console.log(tempState, "ppppppppp");
  }

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Menu Pricing Calculator</h4>
                    <div class="row justify-content-between align-items-center w-100 mx-0">
                      <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                        <div class="search-box mt-0">
                          <form
                            action="/productions"
                            id="MenuItemIndexForm"
                            method="get"
                            accept-charset="utf-8"
                          >
                            {" "}
                            <input
                              name="keyword"
                              placeholder="Search"
                              type="text"
                              id="MenuItemKeyword"
                            />{" "}
                            <input type="submit" />
                          </form>
                        </div>{" "}
                      </div>
                      <div class="btns col-sm-7 col-12 align-right px-0 d-flex align-items-center justify-content-end">
                        <button
                          onClick={() => {
                            const data = { prices: postState };
                            console.log(data);
                            dispatch(actions?.postMenuPricingDetails(data));
                          }}
                          id=""
                          type="Submit"
                        >
                          Update Prices
                        </button>
                        <button id="cancel" type="button">
                          Cancel
                        </button>
                      </div>
                    </div>

                    <div className="shadowclass mt-0 px-0">
                      <div className="table-responsive">
                        <table className="checklist-table menu-pricing table-striped">
                          <thead>
                            <tr>
                              <th>Category </th>
                              <th className="col-2">Menu Item Name </th>
                              <th className="col-2">Component Item List</th>
                              <th className="text-right">
                                Total Cost Per Menu Item{" "}
                              </th>
                              <th>Sales Types</th>
                              <th class="print-width-20">Menu Price </th>
                              <th class="print-width-20">Profit Margin </th>
                            </tr>
                          </thead>
                          <tbody>
                            {menuPricingDetails?.menuItems?.map((item, idx) => (
                              <tr class="menu_item_row">
                                <td>
                                  <span class="">
                                    {item?.other_category?.name}
                                  </span>{" "}
                                </td>
                                <td>{item?.menu_item_name}</td>
                                <td>
                                  {item?.component_list_item?.map((el) => (
                                    <div>{`${el?.unit_amount} ${el?.unit?.symbol} of ${el?.ingredient?.ingredient_name}`}</div>
                                  ))}

                                  <br />
                                </td>
                                <td className="align-right">
                                  {item?.total_cost_per_menu_item}{" "}
                                </td>
                                <td colspan="3">
                                  <table class="w-100 no-alt-bg">
                                    <tbody>
                                      {item?.pos_menuitems_price?.map(
                                        (itemEl, itemElIdx) => (
                                          <tr class="sub_menu_item_row">
                                            <td>
                                              <span class="count_enclosure">
                                                {itemEl?.sales_type?.type_name}
                                              </span>
                                            </td>
                                            <td class="count-unit">
                                              <span class="count_enclosure">
                                                <span class="dolor-sign">
                                                  {menuPricingDetails?.currency}
                                                </span>
                                                <input
                                                  value={
                                                    postState?.[idx]
                                                      ?.PosMenuitemsPrice?.[
                                                      itemElIdx
                                                    ]?.menu_price
                                                  }
                                                  class="menu_price number currency"
                                                  step="1"
                                                  tofixed="2"
                                                  min="0"
                                                  type="text"
                                                  id="MenuItem0PosMenuitemsPrice471MenuPriceShow"
                                                />{" "}
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  class="addReason incDecCount plus_Custome"
                                                  dir="inc"
                                                  onClick={() => {
                                                    handleClick(
                                                      "menu_price",
                                                      item?.id,
                                                      itemEl?.id,
                                                      "inc"
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src="/img/plus.svg"
                                                    height="20"
                                                    width="15"
                                                    alt=""
                                                  />
                                                </a>
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    handleClick(
                                                      "menu_price",
                                                      item?.id,
                                                      itemEl?.id,
                                                      "dec  "
                                                    );
                                                  }}
                                                  class="addReason incDecCount minsucustom"
                                                  dir="dec"
                                                >
                                                  <img
                                                    src="/img/minus.svg"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                            </td>
                                            <td class="count-unit">
                                              <span class="count_enclosure">
                                                <input
                                                  name="data[MenuItem][0][PosMenuitemsPrice][471][profit_margin_show]"
                                                  value={
                                                    postState?.[idx]
                                                      ?.PosMenuitemsPrice?.[
                                                      itemElIdx
                                                    ]?.profit_margin
                                                  }
                                                  class="profit_margin number number_format"
                                                  step="1"
                                                  tofixed="2"
                                                  min="0"
                                                  type="text"
                                                  id="MenuItem0PosMenuitemsPrice471ProfitMarginShow"
                                                />{" "}
                                                <span class="percent-sign">
                                                  %
                                                </span>
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    handleClick(
                                                      "profit_margin",
                                                      item?.id,
                                                      itemEl?.id,
                                                      "inc"
                                                    );
                                                  }}
                                                  class="addReason incDecCount plus_Custome"
                                                  dir="inc"
                                                >
                                                  <img
                                                    src="/img/plus.svg"
                                                    height="20"
                                                    width="15"
                                                    alt=""
                                                  />
                                                </a>
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    handleClick(
                                                      "profit_margin",
                                                      item?.id,
                                                      itemEl?.id,
                                                      "dec"
                                                    );
                                                  }}
                                                  class="addReason incDecCount minsucustom"
                                                  dir="dec"
                                                >
                                                  <img
                                                    src="/img/minus.svg"
                                                    alt=""
                                                  />
                                                </a>
                                              </span>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            ))}

                            {/* <tr class="menu_item_row">
                              <td>
                                <span class="">Beers</span>{" "}
                              </td>
                              <td>1L Guinness Draft</td>
                              <td>
                                <span>1000 ml of Guinness Draught </span>
                              </td>
                              <td className="align-right">$11.87</td>
                              <td colspan="3">
                                <table class="w-100 no-alt-bg">
                                  <tbody>
                                    <tr class="sub_menu_item_row">
                                      <td>
                                        <span class="count_enclosure">
                                          Dine-In{" "}
                                        </span>
                                      </td>
                                      <td class="count-unit">
                                        <span class="count_enclosure">
                                          <span class="dolor-sign">$</span>
                                          <input
                                            name="data[MenuItem][0][PosMenuitemsPrice][471][menu_price_show]"
                                            value="54.00"
                                            class="menu_price number currency"
                                            step="1"
                                            tofixed="2"
                                            min="0"
                                            type="text"
                                            id="MenuItem0PosMenuitemsPrice471MenuPriceShow"
                                          />{" "}
                                          <a
                                            href="#"
                                            class="addReason incDecCount plus_Custome"
                                            dir="inc"
                                          >
                                            <img
                                              src="/img/plus.svg"
                                              height="20"
                                              width="15"
                                              alt=""
                                            />
                                          </a>
                                          <a
                                            href="#"
                                            class="addReason incDecCount minsucustom"
                                            dir="dec"
                                          >
                                            <img src="/img/minus.svg" alt="" />
                                          </a>
                                        </span>
                                      </td>
                                      <td class="count-unit">
                                        <span class="count_enclosure">
                                          <input
                                            name="data[MenuItem][0][PosMenuitemsPrice][471][profit_margin_show]"
                                            value="100.00"
                                            class="profit_margin number number_format"
                                            step="1"
                                            tofixed="2"
                                            min="0"
                                            type="text"
                                            id="MenuItem0PosMenuitemsPrice471ProfitMarginShow"
                                          />{" "}
                                          <span class="percent-sign">%</span>
                                          <a
                                            href="#"
                                            class="addReason incDecCount plus_Custome"
                                            dir="inc"
                                          >
                                            <img
                                              src="/img/plus.svg"
                                              height="20"
                                              width="15"
                                              alt=""
                                            />
                                          </a>
                                          <a
                                            href="#"
                                            class="addReason incDecCount minsucustom"
                                            dir="dec"
                                          >
                                            <img src="/img/minus.svg" alt="" />
                                          </a>
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Pricing;
